import { subscribe } from 'shared/store'
import {
  trackEvent,
  isExperimentEnabled
} from 'views/assets/scripts/optimizely'
import { INIT_CROSSSELL } from 'shared/store/ducks/events'
import { HOME_CSW_AS_SLIDER } from 'shared/experiments/consts'

const SELECTOR_FEATURE_WRAPPPER = `[data-experiment="${HOME_CSW_AS_SLIDER}"]`
const SELECTOR_SLIDER_ITEM = '[data-clientside-hook~="slider__item"]'
const OPTIMIZELY_EVENT_CLICK_ON_XSELL_ITEM =
  'COM - HOME - Click on CrossSell Product'

export default () => {
  if (!isExperimentEnabled(HOME_CSW_AS_SLIDER)) {
    return
  }
  subscribe.after(INIT_CROSSSELL, ({ selector }) => {
    if (!selector || selector !== '[data-crosssell-id="2"]') {
      return
    }

    const activePdpSliderXsell = [
      ...document.querySelectorAll(SELECTOR_FEATURE_WRAPPPER)
    ].find(wrapper => wrapper.innerHTML !== '')

    if (!activePdpSliderXsell) return

    const sliderItems = document.querySelectorAll(SELECTOR_SLIDER_ITEM)

    sliderItems.forEach(item => {
      item.addEventListener('click', () => {
        trackEvent(OPTIMIZELY_EVENT_CLICK_ON_XSELL_ITEM)
      })
    })
  })
}
